<template>
  <Modal
    cancel-variant="tertiary"
    :tracking="{
      action: 'checkout',
      topicKey: 'account_not_verified',
    }"
    @cancel="emit('close')"
    @confirm="redirectToVerification"
  >
    <template #headline>
      {{ $t('account.modal.notverified.title') }}
    </template>
    <section class="flex flex-col items-center">
      <p>{{ $t('account.modal.notverified.message') }}</p>
      <Illustration name="not-verified" />
    </section>
    <template #confirm>
      {{ $t('account.modal.notverified.confirm') }}
    </template>
    <template #cancel>
      {{ $t('account.modal.notverified.cancel') }}
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import type {
  AccountVerificationStatusModalEmit,
  AccountVerificationStatusModalProps,
} from '../utils/types'

const { navigateToLocalized } = useRouterUtils()

const props = defineProps<AccountVerificationStatusModalProps>()
const emit = defineEmits<AccountVerificationStatusModalEmit>()

const redirectToVerification = () => {
  navigateToLocalized(
    createRedirectLocation({ path: '/verification' }, props.redirect ?? '/account'),
    {
      replace: true,
    },
  )
}
</script>
